"use client"
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/Accordion";
import { Checkbox } from "@/components/ui/checkbox";
import { PersianNum } from "@/util/tools/PersianNum";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";
import { LoadAttribute } from "../Action";
import { removeBrandParameter } from "./BrandListCategories";

interface DataAttribute {
    property_name: string;
    Attributes: Attribute[];
}

interface Attribute {
    attribute_name: string;
    id: number;
}

type Props = {
    url: string;
    catId: number;
};

const option = [
    {
        value: 0,
        label: `${PersianNum(0)}  تومان`,
    },
    {
        value: 200000,
        label: `${PersianNum(200)} هزار تومان`,
    },
    {
        value: 300000,
        label: `${PersianNum(300)} هزار تومان`,
    },
    {
        value: 500000,
        label: `${PersianNum(500)} هزار تومان`,
    },
    {
        value: 1000000,
        label: `${PersianNum(1)} میلیون تومان`,
    },
    {
        value: 2000000,
        label: `${PersianNum(2)} میلیون تومان`,
    },
    {
        value: 5000000,
        label: `${PersianNum(5)} میلیون تومان`,
    },
    {
        value: 10000000,
        label: `${PersianNum(10)} میلیون تومان`,
    },
];

const option2 = [
    {
        value: 300000,
        label: `${PersianNum(300)} هزار تومان`,
    },
    {
        value: 400000,
        label: `${PersianNum(400)} هزار تومان`,
    },
    {
        value: 500000,
        label: `${PersianNum(500)} هزار تومان`,
    },
    {
        value: 1000000,
        label: `${PersianNum(1)} میلیون تومان`,
    },
    {
        value: 2000000,
        label: `${PersianNum(2)} میلیون تومان`,
    },
    {
        value: 5000000,
        label: `${PersianNum(5)} میلیون تومان`,
    },
    {
        value: 10000000,
        label: `${PersianNum(10)} میلیون تومان`,
    },
    {
        value: 30000000,
        label: `بیشتر از: ${PersianNum(10)} میلیون تومان`,
    },
];

const AttributeListCategories = ({ url, catId }: Props) => {
    const [loading, setLoading] = useState(true);
    const [listAttribute, setListAttribute] = useState<any>([]);
    const router = useRouter();
    const pathname = usePathname();
    const [loadingPrice, setLoadingPrice] = useState(false);
    const searchParams = useSearchParams();
    const paths = removeBrandParameter(url, "&attr=[");
    const getAttr: any = searchParams.get("attr");
    const max: any = searchParams.get("maxprice");
    const min: any = searchParams.get("minprice");
    const maxP = max ? (max < min ? 30000000 : max) : 30000000;
    const minP = min ? min : 0;
    const [maxPrice, setMaxPrice] = useState(
        option2.filter((i) => i.value == maxP)[0]
    );
    const [minPrice, setMinPrice] = useState(
        option.filter((i) => i.value == minP)[0]
    );

    useEffect(() => {
        if (loading) {
            LoadAttribute(catId).then((data) => {
                setListAttribute(data.data);
                setLoading(false);
            })
        }
    }, [catId, loading])

    let attr: any = getAttr ? JSON.parse(getAttr) : [];
    const addAttrUrl = (id: number) => {
        const check = attr.some((i: any) => i === id);
        if (check) {
            const x = attr.filter((i: any) => i !== id);
            const b = x[0] ? `&attr=${JSON.stringify(x)}` : "";
            router.push(`${pathname}?page=1${paths}${b}`);
        } else {
            attr.push(id);
            const x = JSON.stringify(attr);
            router.push(`${pathname}?page=1${paths}&attr=${x}`);
        }
    };

    const onChecked = (id: number) => {
        const check = attr.some((i: any) => i === id);
        return check;
    };

    const pushPrice = () => {
        setLoadingPrice(true);
        const check = url.includes("maxprice")
            ? url
                .replace(/&maxprice=\d+/, `&maxprice=${maxPrice?.value}`)
                .replace(/&minprice=\d+/, `&minprice=${minPrice?.value}`)
            : `${url}&maxprice=${maxPrice.value}&minprice=${minPrice?.value}`;
        router.push(`${pathname}?page=1${check}`);
        setLoadingPrice(false);
    };


    return (
        <div>
            {listAttribute.map((attr: DataAttribute, index: number) =>
                <Accordion type="single" collapsible className="w-full" key={index}>
                    <AccordionItem value={attr.property_name} className="p-2">
                        <AccordionTrigger className="text-purple-950 dark:text-slate-200 py-2 font-semibold">{attr.property_name}</AccordionTrigger>
                        <AccordionContent>
                            <div className="max-h-32 w-full overflow-auto scrollbar-thumb-slate-300 scrollbar-track-slate-100 scrollbar-thin" >
                                {
                                    attr.Attributes.map((item: Attribute) =>
                                        <div className="p-1 " key={item.id}>
                                            <div key={item.id} className="flex w-full items-center justify-between">
                                                <Checkbox
                                                    checked={onChecked(item.id)}
                                                    onClick={() => addAttrUrl(item.id)} id="terms" />

                                                <span className="ml-2 text-sm leading-5 font-medium dark:text-slate-200 text-purple-950">
                                                    {item.attribute_name}
                                                </span>
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                        </AccordionContent>
                    </AccordionItem>
                </Accordion>
            )}
        </div>
    )
}

export default AttributeListCategories